// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1lW6T","header":"ReportDetails_header__1Y3Xg","title":"ReportDetails_title__1iXEs","left":"ReportDetails_left__20OQN"};